import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import AtlasElement, { type AtlasElementProps } from "@/components/atlas-element";
import styles from "./atlas-notification-center-group.scss";

import "@/components/display/atlas-text/atlas-text";

export type NotificationCenterCardProps = AtlasElementProps & {
    header: string;
};

/**
 * @dependency atlas-text
 *
 * @slot default - Slot para o conteúdo do grupo de notificações.
 *
 * @tag atlas-notification-center-group
 */
@customElement("atlas-notification-center-group")
export default class AtlasNotificationCenterGroup extends AtlasElement {
    static styles = styles;

    /** Título do grupo */
    @property({ type: String }) header: string;

    /** @internal */
    public render() {
        return html`
            <div class="notification-group">
                <atlas-text size="sm" bold muted>${this.header}</atlas-text>
                <div class="notification-group-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-notification-center-group": AtlasNotificationCenterGroup;
    }
}
